<template>
    <div>
        <v-toolbar
            class="pl-0 border-radius-left-right mt-4 primary-header"
            height="50"
            dense
            dark
            flat
            :class="{ 'pr-0': $breakpoint.mdAndDown }"
            v-if="!isInplay"
        >
            <v-fade-transition leave-absolute>
                <live-label text="UPCOMING" color="blue" left></live-label>
            </v-fade-transition>

            <div
                class="d-flex border-radius-left align-self-stretch white--text"
                :class="{
                    'col-12 pl-3 ': $breakpoint.mdAndUp,
                    'pr-0 pl-0  position-relative': $breakpoint.mdAndDown
                }"
            >
                <!-- <div v-if="openable && $breakpoint.mdAndUp" class="align-self-center">
            <v-fade-transition>
              <v-icon v-if="open" color="white" class="flex-0 mr-2" size="14">
                mdi-minus
              </v-icon>
              <v-icon v-else color="white" class="flex-0 mr-2" size="14">
                mdi-plus
              </v-icon>
            </v-fade-transition>
          </div> -->
                <v-btn
                    class="ma-0 px-1 py-2 d-flex flex-column white--text text-capitalize text-left primary-title btn-fixed font-weight-bold"
                    color="transparent"
                    depressed
                    tile
                    height="100%"
                    @click.native.stop
                >
                    <!-- <span class="match-title">{{ subtitle }}</span> -->
                    <!-- <br v-if="subtitle" /> -->
                    <!-- <span class="match-time" :class="{ 'wrap-subtitle': subtitle }"> Need to add subtitle props -->
                    <span
                        class="text-subtitle-1"
                        :class="{
                            'wrap-subtitle': true,
                            'text-caption': $vuetify.breakpoint.smAndDown
                        }"
                    >
                        {{ title }}
                    </span>
                    <!-- <span class="match-time">{{title}}</span> Need to add title props  -->
                </v-btn>
            </div>
        </v-toolbar>
        <template v-if="isInplay">
            <v-expansion-panels class="dropdown-parent" flat tile multiple>
                <v-expansion-panel
                    v-for="(match, i) in matches"
                    :key="'match' + i"
                    class="dropdown border horse-tile"
                    :class="{ 'rounded-end': match.status === 'Enable' }"
                >
                    <template
                        v-if="
                            match.parentCategory &&
                            match.parentCategory._id &&
                            match.status === 'Enable'
                        "
                    >
                        <v-expansion-panel-header
                            v-if="match.status === 'Enable'"
                            class="pl-0 pt-0 pb-0 align-self-stretch dropdown dark-border font-weight-bold dark-border-racing"
                        >
                            <v-row no-gutters>
                                <v-col cols="12" class="pl-2 py-2">
                                    <div>
                                        <div
                                            v-if="
                                                getTitle(match?.marketStartTime)
                                            "
                                            class="calendar-space primary--text"
                                            :class="
                                                $breakpoint.xsAndUp
                                                    ? 'pl-1'
                                                    : 'px-1'
                                            "
                                        >
                                            {{
                                                getTitle(match?.marketStartTime)
                                            }}
                                        </div>
                                        <div
                                            class="manage-overflow match-name mt-2"
                                        >
                                            {{ match?.eventName }}
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>
                            <template v-slot:actions>
                                <div class="d-flex">
                                    <div class="mr-8 d-flex align-items-center">
                                        <!-- <v-img
                        :src="require('@/assets/images/clock.webp')"
                        class="mr-2"
                        :height="$vuetify.breakpoint.smAndUp ? 20 : 14"
                        :width="$vuetify.breakpoint.smAndUp ? 20 : 14"
                      >
                      </v-img> -->

                                        <!-- <span>
                        {{ $moment(match.marketStartTime).format('HH:mm') }}
                      </span> -->

                                        <span class="match-specs">
                                            {{ match.name }}
                                        </span>
                                    </div>
                                    <v-icon
                                        color="black"
                                        class="whitebg"
                                        :icon="
                                            expanded
                                                ? 'mdi-chevron-up'
                                                : 'mdi-chevron-down'
                                        "
                                    >
                                        mdi-chevron-down
                                    </v-icon>
                                </div>
                            </template>
                        </v-expansion-panel-header>

                        <v-expansion-panel-content
                            class="pa-0 dark-border-racing"
                        >
                            <item-odds-racing
                                v-if="
                                    !$auth.user ||
                                    !(
                                        match &&
                                        match.eventType &&
                                        match.eventType.name === 'Cricket' &&
                                        $auth.user &&
                                        !$auth.user.matchOdds &&
                                        match.name &&
                                        match.name.toLowerCase() ===
                                            'match odds'
                                    )
                                "
                                :key="match.betfairId"
                                :market="match"
                                :runners="
                                    match &&
                                    match.runners &&
                                    Array.isArray(match.runners) &&
                                    match.runners.length <= 0
                                        ? [{ name: match.eventName }]
                                        : match.runners
                                "
                                :market-id="match.betfairId"
                                :matchodds-bookmaker="isMatchoddsBookmaker"
                                :to="
                                    match.eventId
                                        ? `/sportsbook/${toKebabCase(
                                              match.eventType.name
                                          )}/${
                                              match.competitionId?._id ??
                                              match.competitionId
                                          }/${
                                              match.parentCategory
                                                  .parentCategory ??
                                              match.parentCategory
                                          }/${match.eventId}?name=${match.name}`
                                        : `/sportsbook/${toKebabCase(
                                              match.eventType.name
                                          )}/${
                                              match.competitionId?._id ??
                                              match.competitionId
                                          }/${
                                              match.parentCategory
                                                  .parentCategory ??
                                              match.parentCategory
                                          }?name=${match.name}`
                                "
                                :max-commission="maxBookmakerCommission"
                                :isInplayLive="false"
                                class="listOdds"
                            >
                            </item-odds-racing>
                        </v-expansion-panel-content>
                    </template>
                </v-expansion-panel>
            </v-expansion-panels>
        </template>
        <template v-else>
            <v-expansion-panels class="dropdown-parent" flat tile multiple>
                <v-expansion-panel
                    v-for="(match, i) in matches"
                    :key="'match' + i"
                    class="dropdown border horse-tile"
                    :class="{ 'rounded-end': match.status === 'upcoming' }"
                >
                    <v-expansion-panel-header
                        v-if="match.status === 'upcoming'"
                        class="pl-0 pt-0 pb-0 align-self-stretch dropdown dark-border font-weight-bold dark-border-racing"
                    >
                        <v-row no-gutters>
                            <v-col cols="12" class="pl-2 py-2">
                                <div>
                                    <div
                                        v-if="getTitle(match?.marketStartTime)"
                                        class="calendar-space primary--text"
                                        :class="
                                            $breakpoint.xsAndUp
                                                ? 'pl-1'
                                                : 'px-1'
                                        "
                                    >
                                        {{ getTitle(match?.marketStartTime) }}
                                    </div>
                                    <div
                                        class="manage-overflow match-name mt-2"
                                    >
                                        {{ match?.eventName }}
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                        <template v-slot:actions>
                            <div class="d-flex">
                                <div class="mr-8 d-flex align-items-center">
                                    <!-- <v-img
                      :src="require('@/assets/images/clock.webp')"
                      class="mr-2"
                      :height="$vuetify.breakpoint.smAndUp ? 20 : 14"
                      :width="$vuetify.breakpoint.smAndUp ? 20 : 14"
                    >
                    </v-img> -->

                                    <!-- <span>
                      {{ $moment(match.marketStartTime).format('HH:mm') }}
                    </span> -->

                                    <span class="match-specs">
                                        {{ match.name }}
                                    </span>
                                </div>
                                <v-icon
                                    color="black"
                                    class="whitebg"
                                    :icon="
                                        expanded
                                            ? 'mdi-chevron-up'
                                            : 'mdi-chevron-down'
                                    "
                                >
                                    mdi-chevron-down
                                </v-icon>
                            </div>
                        </template>
                    </v-expansion-panel-header>

                    <v-expansion-panel-content class="pa-0 dark-border-racing">
                        <item-odds-racing
                            v-if="
                                !$auth.user ||
                                !(
                                    match &&
                                    match.eventType &&
                                    match.eventType.name === 'Cricket' &&
                                    $auth.user &&
                                    !$auth.user.matchOdds &&
                                    match.name &&
                                    match.name.toLowerCase() === 'match odds'
                                )
                            "
                            :key="match.betfairId"
                            :market="match"
                            :runners="
                                match &&
                                match.runners &&
                                Array.isArray(match.runners) &&
                                match.runners.length <= 0
                                    ? [{ name: match.eventName }]
                                    : match.runners
                            "
                            :market-id="match.betfairId"
                            :matchodds-bookmaker="isMatchoddsBookmaker"
                            :to="
                                match.eventId
                                    ? `/sportsbook/${toKebabCase(
                                          match.eventType.name
                                      )}/${
                                          match.competitionId?._id ??
                                          match.competitionId
                                      }/${
                                          match.parentCategory.parentCategory ??
                                          match.parentCategory
                                      }/${match.eventId}?name=${match.name}`
                                    : `/sportsbook/${toKebabCase(
                                          match.eventType.name
                                      )}/${
                                          match.competitionId?._id ??
                                          match.competitionId
                                      }/${
                                          match.parentCategory.parentCategory ??
                                          match.parentCategory
                                      }?name=${match.name}`
                            "
                            :max-commission="maxBookmakerCommission"
                            :isInplayLive="false"
                            class="listOdds"
                        >
                        </item-odds-racing>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </template>
    </div>
</template>
<script>
import ItemOddsRacing from "./ItemOddsRacing.vue"
import LiveLabel from "./LiveLabel.vue"

export default {
    components: { LiveLabel, ItemOddsRacing },
    props: {
        title: { type: String, default: "", required: true },
        matches: { default: [], required: true },
        isInplay: { type: Boolean, default: false, required: false }
    },
    data() {
        return {
            HorseMatches: [
                "Turffontein (ZA)",
                "Newbury (GB)",
                "Turffontein (ZA)",
                "Yarmouth (GB)",
                "Nottingham (GB)"
            ],
            isMatchoddsBookmaker: false,
            maxBookmakerCommission: 0
        }
    },
    computed: {},
    methods: {
        toKebabCase(inputString) {
            return inputString.replace(/ /g, "-").toLowerCase()
        },
        getTitle(startTime) {
            const fixturedate = this.$moment(startTime)
            // if (this.showDate) {
            if (this.$moment().isSame(this.$moment(fixturedate), "week")) {
                return this.$moment(fixturedate).calendar()
                // return this.$moment(fixturedate).endOf('day').fromNow()
            } else {
                return this.$moment(fixturedate).format("ddd, DD/MM hh:mm A")
                // return this.$moment(fixturedate).endOf('day').fromNow()
            }
            // } else {
            //   return false
            // }
        }
    }
}
</script>

<style lang="scss" scoped>
$primary: var(--v-primary-base);

.vw-100 {
    width: calc(100vw - 20px);

    .v-toolbar__content {
        width: calc(100vw - 20px);
    }
}

.v-toolbar__content .v-btn.v-btn--icon.v-size--default,
.v-toolbar__extension .v-btn.v-btn--icon.v-size--default {
    height: auto;
    width: auto;
    padding: 0 0.2rem;
}

.v-application--is-ltr .v-toolbar__content > .v-btn.v-btn--icon:last-child,
.v-application--is-ltr .v-toolbar__extension > .v-btn.v-btn--icon:last-child {
    margin: 0 !important;
}

.topbar-full {
    background-color: $primary !important;
    border: 0.08rem solid $primary;
    box-shadow: 0px 0px 5px 0px $primary;
    border-color: $primary;
    border-bottom: 0;
    max-width: 60%;

    .wrap-subtitle {
        max-width: 60%;
        white-space: normal;
        word-wrap: break-word;

        @media only screen and (max-width: 767px) {
            max-width: calc(100% - 30px);
            text-overflow: ellipsis;
            height: 28px;
            overflow: hidden;
        }
    }
}

.wrap-subtitle {
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    white-space: normal;
    word-wrap: break-word;
}

.pl-0 .v-toolbar__content {
    padding-left: 0 !important;
    padding-right: 0 !important;
}

.topbar {
    background-color: $primary !important;
    /* border: 0.08rem solid #fa7b04; */
    /* box-shadow: 0px 0px 5px 0px #fa7b04; */
    /* border-color: #fa7b04; */
    /* border-bottom: 0; */
    overflow: hidden;

    @media only screen and (max-width: 992px) {
        width: 55%;
    }
}

.primary-header {
    background: $primary !important;
}

.border-radius-left-right {
    border-top-right-radius: 1.1rem !important;
    border-top-left-radius: 1.1rem !important;
}

.border-radius-left {
    border-top-left-radius: 1.1rem !important;
}

.match-title {
    width: (100vw - 50vw);
    white-space: normal;
    word-wrap: break-word;
}

a.caption.ma-0.px-1.py-2.d-flex.flex-column.white--text.text-capitalize.text-left.primary-title.v-btn.v-btn--has-bg.v-btn--router.v-btn--tile.theme--dark.v-size--default.transparent.btn-fixed {
    flex: auto;
    align-items: flex-start;
}

.blackbg {
    background: black !important;
}

.horse-tile {
    background: rgb(255, 255, 255) !important;
    color: black !important;
}

.whitebg {
    background: white !important;
}

.rounded-end:last-child {
    border-bottom-right-radius: 1rem !important;
    border-bottom-left-radius: 1rem !important;
}

v-expansion-panel--active:not(:first-child),
.v-expansion-panel {
    margin-top: 0px;
}

.dark-border-racing {
    border-bottom: 1px solid black;
}

.dropdown-parent:last-child {
    border-bottom-left-radius: 1rem !important;
    border-bottom-right-radius: 1rem !important;
}

.match-name {
    font-size: 0.75rem;

    @media only screen and (max-width: 375px) {
        font-size: 0.6rem !important;
    }
}

.match-specs {
    font-size: 0.625rem;

    @media only screen and (max-width: 375px) {
        font-size: 0.4rem !important;
    }
}

.calendar-space {
    /* height: 28px;*/
    width: 100%;
    display: block;
    text-align: left;
    white-space: normal;
    font-size: 0.65rem;
    font-weight: normal;
    padding-left: 0 !important;
    /* margin-left: -5px; */
}

@media only screen and (max-width: 712px) {
    .calendar-space {
        font-size: 0.6rem;
    }

    .v-btn--icon.v-size--default {
        width: auto;
        height: auto;
    }

    .v-btn--icon.v-size--default .v-icon,
    .v-btn--fab.v-size--default .v-icon {
        height: 18px;
        font-size: 18px;
        width: 18px;
    }
}

@media only screen and (max-width: 720px) {
    .calendar-space {
        font-size: 0.45rem;
        white-space: nowrap;
        font-weight: 700;
    }
}

@media only screen and (max-width: 375px) {
    .calendar-space {
        font-size: 0.37rem;
        white-space: inherit;
    }
}
</style>